/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table, Tooltip, Alert } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';

const CustomRow = (record) => {
  if (record?.className.includes('disabled__table-bulk-row__item-missing')) {
    return (
      <Tooltip title="SKU Code is incorrect.">
        <tr {...record} />
      </Tooltip>
    );
  }
  if (record?.className.includes('disabled__table-bulk-row')) {
    return (
      <Tooltip title="This product is not activated in this Business Unit">
        <tr {...record} />
      </Tooltip>
    );
  }
  if (record?.className.includes('disabled__incorrect-qty')) {
    return (
      <Tooltip title="Quantity should be more than zero.">
        <tr {...record} />
      </Tooltip>
    );
  }
  return (<tr {...record} />);
};

/**
 *
 */
const BulkProductSoPreview = ({
  getProductBySkusLoading, filteredData, data, handleDelete, onBulkUpload, callback, adjustmentType,
}) => {
  const [errorMessage, setErrorMessage] = useState(1);
  let showErrorMessage = 1;

  const getQuantityOfSku = (key) => filteredData?.filter((item) => item.key === key)[0]?.quantity;
  const getUnitPriceOfSku = (key) => filteredData?.filter((item) => item.key === key)[0]?.unit_price;
  const getDiscountOfSku = (key) => filteredData?.filter((item) => item.key === key)[0]?.line_discount_percentage;
  const getFreeQuantityOfSku = (key) => filteredData?.filter((item) => item.key === key)[0]?.free_quantity;

  const columns = [
    {
      title: 'PRODUCT REF#',
      render: (record) => (
        <React.Fragment>
          {record?.internal_sku_code ? (
            <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
              {' '}
              {record?.internal_sku_code}
            </Link>
          ) : ''}
        </React.Fragment>
      ),
    },
    // {
    //   title: 'INTERNAL REF#',
    //   render: (record) => (
    //     <React.Fragment>
    //       {record?.ref_product_code ? (
    //         <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
    //           {' '}
    //           {record?.ref_product_code}
    //         </Link>
    //       ) : ''}
    //     </React.Fragment>
    //   ),
    // },
    {
      title: 'PRODUCT',
      render: (record) => (<div style={{ maxWidth: '200px' }}>{record?.product_sku_name || ''}</div>),
    },
    {
      title: 'QUANTITY',
      render: (record, index) => `${getQuantityOfSku(record?.key) || '0'} ${record?.uom_info?.uqc?.toProperCase() || ''}`,
    },
    {
      title: 'UNIT PRICE',
      render: (record, index) => `${getUnitPriceOfSku(record?.key) || '0'}`,
    },
    {
      title: 'DISCOUNT',
      render: (record, index) => `${getDiscountOfSku(record?.key) || '0'}`,
    },
    {
      title: 'FREE QUANTITY',
      render: (record, index) => `${getFreeQuantityOfSku(record?.key) || '0'}`,
    },
    {
      title: '',
      render: (text, record) => (
        <Fragment>

          <div className="bulk-preview__delete-line-button" onClick={() => handleDelete(record.key)}>
            <CloseOutlined />
          </div>

        </Fragment>
      ),
      width: '40px',
    },
  ];

  const isDataValid = () => {
    for (let i = 0; i < data?.length; i++) {
      if (!data[i]?.tenant_product?.[0]?.tenant_product_id || !(getQuantityOfSku(data[i]?.key) >= 0)) {
        return false;
      }
    }
    return true;
  };

  /**
   *
   */
  const addData = () => {
    onBulkUpload(data, filteredData);
    callback();
  };

  const getRowClassName = (record) => {
    let classNames = '';
    if (!record?.tenant_product?.[0]?.tenant_product_id) classNames += 'disabled__table-bulk-row ';
    if (!record?.product_sku_id) classNames += 'disabled__table-bulk-row__item-missing ';
    if (!(Number(getQuantityOfSku(record?.key)) >= 0)) classNames += 'disabled__incorrect-qty ';
    if (adjustmentType === 'OUTWARD') {
      for (let i = 0; i < data?.length; i++) {
        if (record?.product_sku_id === data[i]?.product_sku_id && record?.key !== data[i]?.key) {
          classNames += 'disabled__table-bulk-row__item-missing ';
        }
      }
    }
    return classNames;
  };

  const showError = () => {
    for (let i = 0; i < data?.length; i++) {
      if (!data[i]?.product_sku_id || !data[i]?.tenant_product?.[0]?.tenant_product_id || !(Number(getQuantityOfSku(data[i]?.key)) >= 0)) {
        // setErrorMessage(0);
        showErrorMessage = 0;
        return true;
      }

      if (adjustmentType === 'OUTWARD') {
        for (let j = i + 1; j < data?.length; j++) {
          if (data[i]?.product_sku_id === data[j]?.product_sku_id) {
            return true;
          }
        }
      }
    }
    return false;
  };
  return (
    <div className="bulk-product-preview__wrapper">
      {showError() ? <Alert message={showErrorMessage === 0 ? 'Please rectify all the records with incorrect or improper information.' : 'Please remove the same product from the list.'} type="error" showIcon />
        : <Alert message="All records have been verified. Click on Verify Products to proceed." type="success" showIcon />}
      &nbsp;
      {' '}
      <div className="bulk-product-preview__table">
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          title={() => `${data?.length} Products`}
          size="small"
          rowClassName={(record) => getRowClassName(record)}
          components={{
            body: {
              row: CustomRow,
            },
          }}
        />
      </div>
      <div className="custom-drawer__footer">
        <H3Button
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          text="Verify Products"
          isLoading={getProductBySkusLoading}
          onClick={() => addData()}
          disabled={getProductBySkusLoading || !isDataValid()}
          style={{
            width: '150px',
            borderRadius: '5px',
            padding: '7px 0px',
            marginLeft: '0',
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ /* Import Reducers here */ UserReducers, ProductReducers }) => ({
  user: UserReducers.user,
  getProductBySkusLoading: ProductReducers.getProductBySkusLoading,

});

const mapDispatchToProps = (/* Import actions here */) => ({

});

BulkProductSoPreview.propTypes = {
  getProductBySkusLoading: PropTypes.bool,
  filteredData: PropTypes.any,
  data: PropTypes.any,
  handleDelete: PropTypes.func,
  onBulkUpload: PropTypes.func,
  callback: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkProductSoPreview));
